import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Hero from "./pages/Hero";
import Main from "./pages/Main";
import LoginPage from "./pages/Login";
import { useRecoilValue } from "recoil";
import SearchInvoice from "./pages/SearchInvoice";
import NavigationPage from "./pages/NavigationPage";
import TransportSearch from "./pages/TransportSearch";
import SupplierLedger from "./pages/SupplierLedger";
import HotelSearch from "./pages/HotelSearch";
import { SnackbarProvider } from "notistack";
import FlightSupplierLedger from "./pages/FlightSupplierLedger";
import HotelSupplierLedger from "./pages/HotelSupplierLedger";
import VisaSupplierLedger from "./pages/VisaSupplierLedger";
import CreditsManage from "./pages/CreditsManage";
import TransportSupplierLedger from "./pages/TransportSupplierLedger";
import FolderLedger from "./pages/FolderLedger";
import CustomerRefundLedger from "./pages/CustomerRefundLedger";
import InvoicedLedger from "./pages/InvoicedLedger";
import SalarySlip from "./pages/SalarySlip";
import FolderReport from "./pages/FolderReport";
import IssuanceRequest from "./pages/IssuanceRequest";
import Issuance from "./pages/Issuance";
import CustomerRefundRequest from "./pages/CustomerRefundRequest";
import RefundProcessing from "./pages/RefundProcessing";
import PaymentConfirmationPage from "./pages/PaymentConfirmationPage";
import PaymentRequestPage from "./pages/PaymentRequestPage";
import { atom } from "recoil";

export const countAtomBool = atom({
  key: "atomkeybool",
  default: false,
});

// FIX 1: Rehydrate auth state from localStorage so it survives refresh & back navigation
export const authAtom = atom({
  key: "authState",
  default: localStorage.getItem("isAuthenticated") === "true",
});

// FIX 2: Use `replace` so the redirect doesn't push a new history entry
// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = useRecoilValue(authAtom);
//   return isAuthenticated ? children : <Navigate to="/" replace />;
// };


const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useRecoilValue(authAtom);
  const localAuth = localStorage.getItem("isAuthenticated") === "true";
  
  return (isAuthenticated || localAuth) ? children : <Navigate to="/" replace />;
};

export const countAtom1 = atom({
  key: "atomkey2",
  default: {
    users: [{ title: "", firstName: "", middleName: "", lastName: "" }],
    travels: [
      { date: "", flightNo: "", from: "", to: "", departure: "", arrival: "" },
    ],
    hotels: [
      {
        name: "",
        date: "",
        checkOutDate: "",
        numberOfRooms: "",
        boardType: "",
      },
    ],
    transport: [
      { date: "", carType: "", pickupLocation: "", dropoffLocation: "" },
    ],
    visa: [{ visaType: "", numberOfVisas: "" }],
    ourReference: "",
    agentsName: "",
    totalQuote: 0,
    totalPaid: 0,
    phoneNumber: "",
    emailAddress: "",
    bank: "",
  },
});

export const agentState = atom({
  key: "agentState",
  default: [], // MUST be an array
});

export const countAtom = atom({
  key: "atomkey",
  default: {
    users: [{ title: "", firstName: "", middleName: "", lastName: "" }],
    travels: [
      { date: "", flightNo: "", from: "", to: "", departure: "", arrival: "" },
    ],
    hotels: [
      {
        name: "",
        date: "",
        checkOutDate: "",
        numberOfRooms: "",
        boardType: "",
      },
    ],
    transport: [
      { date: "", carType: "", pickupLocation: "", dropoffLocation: "" },
    ],
    visa: [{ visaType: "", numberOfVisas: "" }],
    ourReference: "",
    agentsName: "",
    totalQuote: 0,
    totalPaid: 0,
    phoneNumber: "",
    emailAddress: "",
    bank: "",
  },
});

function App() {
  return (
    <SnackbarProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route
            path="/hero"
            element={
              <ProtectedRoute>
                <Hero />
              </ProtectedRoute>
            }
          />
          <Route
            path="/IssuanceRequest"
            element={
              <ProtectedRoute>
                <IssuanceRequest />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Issuance"
            element={
              <ProtectedRoute>
                <Issuance />
              </ProtectedRoute>
            }
          />
          {/*here here  */}

 <Route
            path="/CustomerRefundRequest"
            element={
              <ProtectedRoute>
                <CustomerRefundRequest />
              </ProtectedRoute>
            }
          />
           <Route
            path="/RefundProcessing"
            element={
              <ProtectedRoute>
                <RefundProcessing />
              </ProtectedRoute>
            }
          />
          {/*  */}
          <Route
            path="/SalarySlip"
            element={
              <ProtectedRoute>
                <SalarySlip />
              </ProtectedRoute>
            }
          />
          <Route
            path="/FolderReport"
            element={
              <ProtectedRoute>
                <FolderReport />
              </ProtectedRoute>
            }
          />

  <Route
            path="/PaymentRequestPage"
            element={
              <ProtectedRoute>
                <PaymentRequestPage />
              </ProtectedRoute>
            }
          />

            <Route
            path="/PaymentConfirmationPage"
            element={
              <ProtectedRoute>
                <PaymentConfirmationPage />
              </ProtectedRoute>
            }
          />



          <Route
            path="/main"
            element={
              <ProtectedRoute>
                <Main />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SearchInvoice"
            element={
              <ProtectedRoute>
                <SearchInvoice />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SupplierLedger"
            element={
              <ProtectedRoute>
                <SupplierLedger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/NavigationPage"
            element={
              <ProtectedRoute>
                <NavigationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/TransportSearch"
            element={
              <ProtectedRoute>
                <TransportSearch />
              </ProtectedRoute>
            }
          />
          <Route
            path="/HotelSearch"
            element={
              <ProtectedRoute>
                <HotelSearch />
              </ProtectedRoute>
            }
          />
          <Route
            path="/FlightSupplierLedger"
            element={
              <ProtectedRoute>
                <FlightSupplierLedger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/HotelSupplierLedger"
            element={
              <ProtectedRoute>
                <HotelSupplierLedger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/VisaSupplierLedger"
            element={
              <ProtectedRoute>
                <VisaSupplierLedger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/TransportSupplierLedger"
            element={
              <ProtectedRoute>
                <TransportSupplierLedger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CreditsManage"
            element={
              <ProtectedRoute>
                <CreditsManage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CustomerRefundLedger"
            element={
              <ProtectedRoute>
                <CustomerRefundLedger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/FolderLedger"
            element={
              <ProtectedRoute>
                <FolderLedger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/InvoicedLedger"
            element={
              <ProtectedRoute>
                <InvoicedLedger />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </SnackbarProvider>
  );
}

export default App;